<template>
    <rkm-table
        :fields="fields"
        :items="data.form.encaminhamentos.concat(data.model.encaminhamentos)"
        hide-filters
        hide-pagination
        tag="div"
    >
        <template v-slot:cell(actions)="row">
            <rkm-button
                color="primary"
                small
                title="Imprimir"
                @click="print(row.item)"
            >
                <rkm-icon icon="print" />
            </rkm-button>

            <rkm-button
                :disabled="Number.isInteger(row.item.id)"
                @click="$emit('edit', row.item)"
                color="primary"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                :disabled="Number.isInteger(row.item.id)"
                @click="handleDestroy(row.item)"
                color="danger"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins.
import { repository, error, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento.atendimentoTriagem')
        }
    },
    data: () => ({
        fields: [
            { key: 'lotacao.ocupacao.codigo', label: 'CBO' },
            { key: 'lotacao.profissional.nome', label: 'Profissional' },
            { key: 'unidadeNomeFantasia', label: 'Unidade' },
            { key: 'infraestruturaNome', label: 'Local de atendimento' },
            { key: 'actions', label: 'Ações', class: "col-min" },
        ]
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        print(item) {
            this.setLoading()

            const data = {
                pacienteId: this.data.form.paciente.id,
                encaminhamentos: [
                    isNaN(item.id)
                        ? {
                            infraestrutura_id: item.infraestruturaId,
                            motivo: item.motivo,
                        }
                        : { id: item.id }
                ],
            }

            this.repositories.impressao.guiaEncaminhamento(null, this.camelObjectKeysToSnakeRecursive(data))
                .then(response => {

                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()

                    URL.revokeObjectURL(url);
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy(item) {
            const destroy = () => new Promise(resolve => {
                resolve(this.data.model.encaminhamentos.splice(
                    this.data.model.encaminhamentos.findIndex(encaminhamento => encaminhamento.id === item.id), 1))
            })

            this.showDeleteConfirmation('Tem certeza que deseja excluir?', destroy)
        },
    },
    mixins: [repository, error, stringCase],
    props: {
        data: { type: Object, required: true },
    },
}
</script>